(function () {
  'use strict';

  var pp          = document.getElementById('krux-pp');
  if (!pp) return;

  var productData   = JSON.parse(pp.dataset.product || '{}');
  var variants      = productData.variants || [];
  var freeShipCents = parseInt(pp.dataset.freeShip || '10000', 10);
  var currentVarId  = parseInt(pp.dataset.variant || '0', 10);

  var selectedOptions = (function () {
    var v = variants.find(function (vv) { return vv.id === currentVarId; });
    return v ? [v.option1, v.option2, v.option3] : [];
  })();

  var slides    = Array.from(document.querySelectorAll('.krux-pp__slide'));
  var thumbs    = Array.from(document.querySelectorAll('.krux-pp__thumb'));
  var dots      = Array.from(document.querySelectorAll('.krux-pp__dot'));
  var stage     = document.getElementById('krux-stage');
  var navPrev   = document.getElementById('krux-nav-prev');
  var navNext   = document.getElementById('krux-nav-next');
  var railEl    = document.getElementById('krux-thumbs');
  var thumbRail = document.getElementById('krux-thumb-rail');
  var upBtn     = document.getElementById('krux-rail-up');
  var dnBtn     = document.getElementById('krux-rail-down');
  var activeIdx = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
  if (activeIdx === -1) activeIdx = 0;

  function scrollThumbIntoRail(thumb) {
    if (!railEl || !thumb) return;
    var railScrollTop = railEl.scrollTop;
    var railH         = railEl.clientHeight;
    var thumbTop      = thumb.offsetTop;
    var thumbBot      = thumbTop + thumb.offsetHeight;
    if (thumbTop < railScrollTop) {
      railEl.scrollTop = thumbTop - 6;
    } else if (thumbBot > railScrollTop + railH) {
      railEl.scrollTop = thumbBot - railH + 6;
    }
  }

  function goToSlide(idx) {
    if (!slides.length) return;
    idx = (idx + slides.length) % slides.length;
    slides[activeIdx].classList.remove('is-active');
    if (thumbs[activeIdx]) {
      thumbs[activeIdx].classList.remove('is-active');
      thumbs[activeIdx].setAttribute('aria-pressed', 'false');
    }
    dots[activeIdx] && dots[activeIdx].classList.remove('is-active');
    activeIdx = idx;
    slides[activeIdx].classList.add('is-active');
    if (thumbs[activeIdx]) {
      thumbs[activeIdx].classList.add('is-active');
      thumbs[activeIdx].setAttribute('aria-pressed', 'true');
    }
    dots[activeIdx] && dots[activeIdx].classList.add('is-active');
    requestAnimationFrame(function () {
      scrollThumbIntoRail(thumbs[activeIdx]);
      updateRailArrows();
    });
  }

  navPrev && navPrev.addEventListener('click', function () { goToSlide(activeIdx - 1); });
  navNext && navNext.addEventListener('click', function () { goToSlide(activeIdx + 1); });

  thumbs.forEach(function (t) {
    t.addEventListener('click', function () { goToSlide(parseInt(t.dataset.thumb, 10)); });
  });
  dots.forEach(function (d) {
    d.addEventListener('click', function () { goToSlide(parseInt(d.dataset.dot, 10)); });
  });

  var touchStartX = 0, touchStartY = 0;
  stage && stage.addEventListener('touchstart', function (e) {
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
  }, { passive: true });
  stage && stage.addEventListener('touchend', function (e) {
    var dx = e.changedTouches[0].clientX - touchStartX;
    var dy = e.changedTouches[0].clientY - touchStartY;
    if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
      goToSlide(activeIdx + (dx < 0 ? 1 : -1));
    }
  }, { passive: true });

  var isZoomed = false;
  stage && stage.addEventListener('click', function () {
    if (window.innerWidth < 768) return;
    isZoomed = !isZoomed;
    stage.classList.toggle('is-zoomed', isZoomed);
    var img = slides[activeIdx] && slides[activeIdx].querySelector('.krux-pp__main-img');
    if (!isZoomed && img) img.style.transform = '';
  });
  stage && stage.addEventListener('mousemove', function (e) {
    if (!isZoomed || window.innerWidth < 768) return;
    var img = slides[activeIdx] && slides[activeIdx].querySelector('.krux-pp__main-img');
    if (!img) return;
    var rect  = stage.getBoundingClientRect();
    var px    = (e.clientX - rect.left) / rect.width;
    var py    = (e.clientY - rect.top) / rect.height;
    var scale = 2.2;
    var tx    = (0.5 - px) * (scale - 1) * 100;
    var ty    = (0.5 - py) * (scale - 1) * 100;
    img.style.transform = 'scale(' + scale + ') translate(' + tx / scale + '%, ' + ty / scale + '%)';
  });
  stage && stage.addEventListener('mouseleave', function () {
    if (!isZoomed) return;
    var img = slides[activeIdx] && slides[activeIdx].querySelector('.krux-pp__main-img');
    if (img) img.style.transform = '';
  });

  function showVariantImage(variant) {
    if (!variant || !variant.featured_image || !variant.featured_image.position) return;
    var targetIdx = variant.featured_image.position - 1;
    if (slides[targetIdx]) goToSlide(targetIdx);
  }

  function updateRailArrows() {
    if (!upBtn || !dnBtn || !railEl) return;
    var atTop = railEl.scrollTop <= 2;
    var atBot = railEl.scrollTop >= railEl.scrollHeight - railEl.clientHeight - 2;
    upBtn[atTop ? 'setAttribute' : 'removeAttribute']('hidden', '');
    dnBtn[atBot ? 'setAttribute' : 'removeAttribute']('hidden', '');
  }

  if (railEl) {
    railEl.addEventListener('wheel', function (e) {
      var canUp = railEl.scrollTop > 0;
      var canDn = railEl.scrollTop < railEl.scrollHeight - railEl.clientHeight;
      if ((e.deltaY < 0 && canUp) || (e.deltaY > 0 && canDn)) {
        e.preventDefault();
        e.stopPropagation();
        railEl.scrollTop += e.deltaY;
      }
    }, { passive: false });
    railEl.addEventListener('scroll', updateRailArrows);
    railEl.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var all = Array.from(railEl.querySelectorAll('.krux-pp__thumb'));
      var idx = all.indexOf(document.activeElement);
      if (idx === -1) return;
      e.preventDefault();
      var next = all[idx + (e.key === 'ArrowDown' ? 1 : -1)];
      if (next) {
        next.focus();
        goToSlide(parseInt(next.dataset.thumb, 10));
      }
    });
  }

  if (upBtn) upBtn.addEventListener('click', function () {
    railEl && railEl.scrollBy({ top: -80, behavior: 'smooth' });
  });
  if (dnBtn) dnBtn.addEventListener('click', function () {
    railEl && railEl.scrollBy({ top: 80, behavior: 'smooth' });
  });

  if (thumbRail && stage && 'ResizeObserver' in window) {
    var ro = new ResizeObserver(function () {
      var h = stage.getBoundingClientRect().height;
      if (h > 0) thumbRail.style.height = h + 'px';
    });
    ro.observe(stage);
  }

  updateRailArrows();

  var shipText = document.getElementById('krux-ship-label');
  var shipFill = document.getElementById('krux-ship-fill');
  var shipBar  = document.getElementById('krux-ship-bar');

  function updateShippingBar() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var total     = cart.total_price || 0;
        var remaining = freeShipCents - total;
        if (!shipText || !shipFill) return;
        if (remaining <= 0) {
          shipText.textContent = '✓ You\'ve unlocked FREE Express Shipping';
          shipFill.style.width = '100%';
          shipBar && shipBar.querySelector('.krux-pp__ship-text').classList.add('is-unlocked');
        } else {
          shipText.textContent = 'You\'re $' + (remaining / 100).toFixed(0) + ' away from FREE Express Shipping';
          shipFill.style.width = Math.min(100, (total / freeShipCents) * 100) + '%';
          shipBar && shipBar.querySelector('.krux-pp__ship-text').classList.remove('is-unlocked');
        }
      })
      .catch(function () {
        if (shipText) shipText.textContent = 'Free Express Shipping over $' + (freeShipCents / 100) + ' AUD';
      });
  }
  updateShippingBar();

  var variantInput = document.getElementById('krux-variant-id');
  var atcBtn       = document.getElementById('krux-atc');
  var atcLabel     = atcBtn && atcBtn.querySelector('.krux-pp__atc-label');
  var priceEl      = document.getElementById('krux-price');
  var compareEl    = document.getElementById('krux-compare');
  var saleBadge    = pp.querySelector('.krux-pp__sale-badge');
  var stickyPrice  = document.getElementById('krux-sticky-price');
  var colourValueEl = pp.querySelector('.krux-pp__opt-selected-value');

  function findVariant(opts) {
    return variants.find(function (v) {
      return (
        (opts[0] == null || v.option1 === opts[0]) &&
        (opts[1] == null || v.option2 === opts[1]) &&
        (opts[2] == null || v.option3 === opts[2])
      );
    });
  }

  function moneyFormat(cents) {
    return '$' + (cents / 100).toFixed(2).replace('.00', '');
  }

  function updateVariantUI(variant) {
    if (!variant) return;
    currentVarId = variant.id;
    if (variantInput) variantInput.value = variant.id;
    if (priceEl) priceEl.textContent = moneyFormat(variant.price);
    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = moneyFormat(variant.compare_at_price);
        compareEl.hidden = false;
        if (saleBadge) saleBadge.hidden = false;
      } else {
        compareEl.hidden = true;
        if (saleBadge) saleBadge.hidden = true;
      }
    }
    if (stickyPrice) stickyPrice.textContent = moneyFormat(variant.price);
    if (atcBtn) {
      atcBtn.disabled = !variant.available;
      atcBtn.setAttribute('aria-disabled', !variant.available);
    }
    if (atcLabel) atcLabel.textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT';
    var stickyBtn = document.getElementById('krux-sticky-btn');
    if (stickyBtn) stickyBtn.disabled = !variant.available;
    if (colourValueEl && variant.option1) colourValueEl.textContent = '— ' + variant.option1;
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
    showVariantImage(variant);
    // Re-apply the held-colour check immediately after any variant change,
    // in case the newly-selected colourway is the one currently on hold
    // (see the held-colours block below) — otherwise a colour swap could
    // briefly show an incorrect enabled/disabled state.
    if (window.kruxApplyWave2 && window.__krux_held_colours__ && window.__krux_held_colours__[productData.handle]) {
      window.kruxApplyWave2();
    }
  }

  function updateAvailability() {
    var optGroups = document.querySelectorAll('.krux-pp__opt-group');
    optGroups.forEach(function (group, gi) {
      group.querySelectorAll('.krux-pp__opt-btn').forEach(function (btn) {
        var testOpts = selectedOptions.slice();
        testOpts[gi] = btn.dataset.value;
        var v = findVariant(testOpts);
        btn.classList.toggle('is-unavail', !!(v && !v.available));
      });
    });
  }

  document.querySelectorAll('.krux-pp__opt-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var groupIdx = parseInt(btn.dataset.optionIndex || btn.closest('.krux-pp__opt-group').dataset.optionIndex, 10);
      selectedOptions[groupIdx] = btn.dataset.value;
      btn.closest('.krux-pp__opt-btns').querySelectorAll('.krux-pp__opt-btn').forEach(function (b) {
        b.classList.toggle('is-sel', b === btn);
      });
      var variant = findVariant(selectedOptions);
      if (variant) updateVariantUI(variant);
      updateAvailability();
    });
  });

  updateAvailability();

  var qtyInput = document.getElementById('krux-qty-input');
  var qtyMinus = document.getElementById('krux-qty-minus');
  var qtyPlus  = document.getElementById('krux-qty-plus');
  qtyMinus && qtyMinus.addEventListener('click', function () {
    if (qtyInput) qtyInput.value = Math.max(1, parseInt(qtyInput.value || 1) - 1);
  });
  qtyPlus && qtyPlus.addEventListener('click', function () {
    if (qtyInput) qtyInput.value = parseInt(qtyInput.value || 1) + 1;
  });

  var form    = document.getElementById('krux-product-form');
  var spinner = form && form.querySelector('.krux-pp__atc-spinner');

  form && form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (atcBtn && atcBtn.disabled) return;
    var qty  = parseInt((qtyInput && qtyInput.value) || 1, 10);
    var body = JSON.stringify({ id: currentVarId, quantity: qty });
    if (atcBtn) atcBtn.disabled = true;
    if (atcLabel) atcLabel.hidden = true;
    if (spinner) spinner.hidden = false;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body
    })
    .then(function (r) { return r.json(); })
    .then(function (item) {
      if (item.status) throw new Error(item.description || 'Could not add to cart.');
      updateShippingBar();
      if (atcLabel) { atcLabel.textContent = 'ADDED ✓'; atcLabel.hidden = false; }
      if (spinner) spinner.hidden = true;
      setTimeout(function () {
        if (atcBtn) atcBtn.disabled = false;
        if (atcLabel) atcLabel.textContent = 'ADD TO CART';
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: item, sourceId: 'krux-product-form', data: { itemCount: item.item_count } } }));
      }, 1800);
    })
    .catch(function (err) {
      if (atcLabel) { atcLabel.textContent = 'TRY AGAIN'; atcLabel.hidden = false; }
      if (spinner) spinner.hidden = true;
      if (atcBtn) atcBtn.disabled = false;
      console.warn('[KRUX] ATC error:', err.message);
    });
  });

  var stickyBar = document.getElementById('krux-sticky-atc');
  var stickyBtn = document.getElementById('krux-sticky-btn');

  if (atcBtn && stickyBar && 'IntersectionObserver' in window) {
    stickyBar.hidden = false;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        stickyBar.setAttribute('aria-hidden', String(entry.isIntersecting));
      });
    }, { threshold: 0 });
    obs.observe(atcBtn);
  }
  stickyBtn && stickyBtn.addEventListener('click', function () { atcBtn && atcBtn.click(); });

  document.querySelectorAll('.krux-pp__acc-trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var panel     = trigger.nextElementSibling;
      var isOpen    = trigger.getAttribute('aria-expanded') === 'true';
      var accordion = trigger.closest('.krux-pp__accordion');
      accordion && accordion.querySelectorAll('.krux-pp__acc-trigger').forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
        var p = t.nextElementSibling;
        if (p) p.classList.remove('is-open');
      });
      if (!isOpen && panel) {
        trigger.setAttribute('aria-expanded', 'true');
        panel.classList.add('is-open');
      }
    });
  });

  var sizeModal   = document.getElementById('krux-size-modal');
  var sizeBtn     = document.getElementById('krux-size-btn');
  var sizeClose   = document.getElementById('krux-size-modal-close');
  var sizeOverlay = document.getElementById('krux-size-modal-overlay');

  function openSizeModal()  { if (sizeModal) { sizeModal.hidden = false; document.body.style.overflow = 'hidden'; } }
  function closeSizeModal() { if (sizeModal) { sizeModal.hidden = true;  document.body.style.overflow = '';       } }

  sizeBtn     && sizeBtn.addEventListener('click', openSizeModal);
  sizeClose   && sizeClose.addEventListener('click', closeSizeModal);
  sizeOverlay && sizeOverlay.addEventListener('click', closeSizeModal);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && sizeModal && !sizeModal.hidden) closeSizeModal();
  });

  var wishlistBtn = document.getElementById('krux-wishlist');
  var WISH_KEY    = 'krux_wishlist_v1';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISH_KEY) || '[]'); } catch (e) { return []; }
  }
  function setWishlist(arr) {
    try { localStorage.setItem(WISH_KEY, JSON.stringify(arr)); } catch (e) {}
  }

  if (wishlistBtn) {
    var pid  = wishlistBtn.dataset.productId;
    var list = getWishlist();
    if (list.indexOf(pid) !== -1) wishlistBtn.classList.add('is-saved');

    wishlistBtn.addEventListener('click', function () {
      var wl   = getWishlist();
      var idx  = wl.indexOf(pid);
      var save = idx === -1;
      if (save) { wl.push(pid); wishlistBtn.classList.add('is-saved'); wishlistBtn.setAttribute('aria-label', 'Remove from wishlist'); }
      else { wl.splice(idx, 1); wishlistBtn.classList.remove('is-saved'); wishlistBtn.setAttribute('aria-label', 'Save to wishlist'); }
      setWishlist(wl);
    });
  }

  (function () {
    var held = window.__krux_held_colours__ || {};
    var heldColours = held[productData.handle];
    if (!heldColours || !heldColours.length) return;

    var labels = (window.__krux_hold_labels__ && window.__krux_hold_labels__[productData.handle]) || {};
    var holdNote  = null;
    var titleBadge = null;

    function getHeldColour() {
      var v = variants.find(function (vv) { return vv.id === currentVarId; });
      var colour = v ? (v.option1 || '').toLowerCase() : '';
      return heldColours.indexOf(colour) !== -1 ? colour : null;
    }

    function removeHoldNote() {
      if (holdNote && holdNote.parentNode) holdNote.parentNode.removeChild(holdNote);
      holdNote = null;
    }

    function removeTitleBadge() {
      if (titleBadge && titleBadge.parentNode) titleBadge.parentNode.removeChild(titleBadge);
      titleBadge = null;
    }

    function applyHold() {
      var colour = getHeldColour();
      removeHoldNote();
      removeTitleBadge();
      if (!colour) {
        // A non-held colour is selected (e.g. Stealth/Black) — completely
        // untouched; leave whatever updateVariantUI() already set.
        return;
      }
      var label = labels[colour] || { short: 'UNAVAILABLE', sub: '' };
      if (atcBtn) {
        atcBtn.disabled = true;
        atcBtn.setAttribute('aria-disabled', 'true');
      }
      if (atcLabel) atcLabel.textContent = label.short;

      if (label.sub && atcBtn && atcBtn.parentNode) {
        holdNote = document.createElement('p');
        holdNote.className = 'krux-pp__hold-note';
        holdNote.style.cssText = 'font-family:Space Grotesk,sans-serif;font-size:11px;font-weight:600;letter-spacing:0.14em;color:#C8102E;text-transform:uppercase;text-align:center;margin:10px 0 0;';
        holdNote.textContent = label.sub;
        atcBtn.parentNode.insertBefore(holdNote, atcBtn.nextSibling);
      }

      // Also surface a short badge line right under the product title —
      // e.g. "REDLINE 01 — ARCHIVED" or "REDLINE WHITE" — so the state is
      // clear even before a customer scrolls down to the buy button.
      if (label.title) {
        var titleRow = pp.querySelector('.krux-pp__title-row');
        if (titleRow && titleRow.parentNode) {
          titleBadge = document.createElement('p');
          titleBadge.className = 'krux-pp__release-badge-text';
          titleBadge.style.cssText = 'font-family:Space Grotesk,sans-serif;font-size:11px;font-weight:700;letter-spacing:0.14em;color:#C8102E;text-transform:uppercase;margin:6px 0 0;';
          titleBadge.textContent = label.title;
          titleRow.parentNode.insertBefore(titleBadge, titleRow.nextSibling);
        }
      }
    }

    // Exposed so updateVariantUI() (defined above, runs on every colour
    // click) can re-apply this immediately on a colour swap.
    window.kruxApplyWave2 = applyHold;

    applyHold();
  })();

})();
